const state = {
    message: '',
    show: false,
}

const getters = {
    message (state) {
        return state.message
    },
    show (state) {
        return state.show
    },
}

const mutations = {
    showDialog (state, message) {
        state.show = true
        state.message = message
    },

    hideDialog (state) {
        state.show = false
    },
}

const actions = {
    showDialog ({ commit }) {
        commit('showDialog')
    },

    hideDialog ({ commit }) {
        commit('hideDialog')
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
